import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import componentBase from '../../../../../../../../../../../src/lib/component-base';

const startColorGradient = 'rgba(129, 162, 202, 0.5)';
const startColorGradientHex = '#8081A2CA';
const endColorGradient = 'rgba(0, 0, 0, 1)';
const endColorGradientHex = '#00000000';

const minutesStringFormat = (minutes) => {
  if (minutes < 60) {
    return `${minutes}m`;
  }

  if (minutes % 60 > 0) {
    return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
  }

  return `${Math.floor(minutes / 60)}h`;
};

@componentBase('FlightMiniTrackerDurations')
export default class FlightMiniTrackerDurations extends React.Component {
  static propTypes = {
    isLanded: PropTypes.bool,
    depDateTimeUTC: PropTypes.string,
    arrDateTimeUTC: PropTypes.string,
    currentPositionTime: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);

    this.muiDefaultProps = {
      topStyle: {
        padding: '0',
        height: 'inherit',
        position: 'relative',
        background: `-webkit-linear-gradient(${startColorGradient}, ${endColorGradient})`, /* For Safari 5.1 to 6.0 */
        background: `-o-linear-gradient(${startColorGradient}, ${endColorGradient})`, /* For Opera 11.1 to 12.0 */
        background: `-moz-linear-gradient(${startColorGradient}, ${endColorGradient})`, /* For Firefox 3.6 to 15 */
        background: `filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=${startColorGradientHex}, endColorstr=${endColorGradientHex})`, /* IE */
        background: `linear-gradient(${startColorGradient}, ${endColorGradient})`, /* Standard syntax */
      },
    };
  }

  _validProps() {
    return this.props.isLanded !== null &&
           this.props.depDateTimeUTC &&
           this.props.arrDateTimeUTC &&
           this.props.currentPositionTime;
  }

  _getElapsedTime(shorthand) {
    if (this._validProps()) {
      let diffDate = this.props.currentPositionTime;
      if (this.props.isLanded === true) {
        diffDate = this.props.arrDateTimeUTC;
      }

      const msDiff = moment(diffDate).diff(moment.utc(this.props.depDateTimeUTC));
      const duration = moment.duration(msDiff);
      const actualMins = (duration.hours() * 60 + duration.minutes()) > 0 ?
        (duration.hours() * 60 + duration.minutes()) : 0;

      return minutesStringFormat(actualMins);
    }

    if (shorthand) {
      return 'N/A';
    }

    return 'Not Available';
  }

  _getRemainingTime(shorthand) {
    if (this._validProps()) {
      if (this.props.isLanded === true) {
        return minutesStringFormat(0);
      }

      const msDiff = moment.utc(this.props.arrDateTimeUTC)
        .diff(moment(this.props.currentPositionTime));
      const duration = moment.duration(msDiff);
      const actualMins = (duration.hours() * 60 + duration.minutes()) > 0 ?
        (duration.hours() * 60 + duration.minutes()) : 0;

      return minutesStringFormat(actualMins);
    }

    if (shorthand) {
      return 'N/A';
    }

    return 'Not Available';
  }

  render() {
    // console.log('[FlightMiniTrackerDurations] render : props', this.props);

    return (
      <div style={this.muiDefaultProps.topStyle}>
        <div style={{ padding: '10px' }}>
          <div className='visible-xs visible-md'><span style={{ fontSize: '12pt' }}>Elapsed</span></div>
          <div className='visible-xs visible-md'><span style={{ fontSize: '14pt', fontWeight: 'bold', color: '#FF9600' }}>{ this._getElapsedTime(true) }</span></div>
          <div className='hidden-xs hidden-md'><span style={{ fontSize: '12pt' }}>Time Elapsed</span></div>
          <div className='hidden-xs hidden-md'><span style={{ fontSize: '14pt', fontWeight: 'bold', color: '#FF9600' }}>{ this._getElapsedTime(false) }</span></div>
        </div>
        <div style={{ padding: '10px', position: 'absolute', bottom: '0' }}>
          <div className='visible-xs visible-md'><span style={{ fontSize: '12pt' }}>Remaining</span></div>
          <div className='visible-xs visible-md'><span style={{ fontSize: '14pt', fontWeight: 'bold', color: '#FF9600' }}>{ this._getRemainingTime(true) }</span></div>
          <div className='hidden-xs hidden-md'><span style={{ fontSize: '12pt' }}>Time Remaining</span></div>
          <div className='hidden-xs hidden-md'><span style={{ fontSize: '14pt', fontWeight: 'bold', color: '#FF9600' }}>{ this._getRemainingTime(false) }</span></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightPositionalInformationSection/children/FlightPositionalInformation/children/FlightMiniTracker/children/FlightMiniTrackerDurations.js